import { EMAIL_LWK_GO_TO_FAILURE_STATE, EMAIL_LWK_GO_TO_INITIAL_STATE, EMAIL_LWK_GO_TO_SUCCESS_STATE } from './actionTypes';
export var goToInitialState = function () { return ({
    type: EMAIL_LWK_GO_TO_INITIAL_STATE,
}); };
export var goToSuccessState = function () { return ({
    type: EMAIL_LWK_GO_TO_SUCCESS_STATE,
}); };
export var goToFailureState = function () { return ({
    type: EMAIL_LWK_GO_TO_FAILURE_STATE,
}); };
export default { goToInitialState: goToInitialState, goToSuccessState: goToSuccessState, goToFailureState: goToFailureState };
